import { Component } from '@angular/core';
import { Nav, NavController } from 'ionic-angular';
// import { ListPage } from '../list/list';
import { HomePage } from '../home/home';
import { SlideContentPage } from '../slidecontent/slidecontent';
import { PortfoliosPage } from '../portfolios/portfolios';

@Component({
  selector: 'page-slides',
  templateUrl: 'slides.html'
})
export class SlidesPage {
  pages: Array<{ title: string; component: any }>;

  constructor(public navCtrl: NavController, public nav: Nav) {
    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'Portfolios', component: PortfoliosPage }
    ];
  }

  openPage(page) {
    this.navCtrl.push(page.component);
  }

  openSlide() {
    this.navCtrl.push(SlideContentPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/slides/slides.ts